/* eslint-disable no-undef */

import React, {PureComponent} from 'react'
import {withStyles} from "@material-ui/core/styles/index";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { Grid, Typography, Fab } from '@material-ui/core';

const styles = theme => ({
    elementWrapper: {
        padding: '0px 16px 24px 16px!important',
        //border: '1px solid #e5e5e5',
        background: '#fbfbfb',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
        transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
        "&:hover": {
            //background: "#f5f5f5",
            boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
        },
        margin: '0px 0px 32px 0px',
        overflow: 'hidden',
        position: 'relative',
        cursor: 'pointer',
        borderRadius: 10
    },
    primaryText: {
        color: theme.palette.primaryColor,
    },
    accentText: {
        color: theme.palette.secondaryColor
    },
    elementText: {
        paddingTop: '14px!important'
    },
    product: {
        color: theme.palette.primaryColor,
    },
    productDescription: {
        fontWeight: 500,
    },
    statusIcon: {
        position: 'absolute',
        right: '-1rem',
        bottom: '-1rem',
        fontSize: '6rem',
        opacity: 0.5,
    },
    status0Icon: {
        color: '#f33b1b'
    },
    status5Icon: {
        color: '#f3ca1b'
    },
    status10Icon: {
        color: '#00b0ff'
    },
    imageWrapper: {
        padding: '16px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    image: {
        width: '100%',
        maxWidth: 130,
    },
    contentWrapper: {},
    elementTitle: {
        lineHeight: '1.4rem'
    },
    elementContentWrapper: {
        padding: '8px',
    },
    button: {
        background: theme.palette.primaryColor,
        color: '#ffffff',
        width: '100%!important',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)!important',
        //maxWidth: 150,
        minWidth: '140px!important',
        lineHeight: '15px',
    },
    rightIcon: {
        marginLeft: 16,
        marginTop: -3,
    },
    buttonWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 16px',
    },
    topDivider: {
        borderTop: '1px solid #eaeaea',
        marginTop: 16,
        paddingTop: 4,
    },
    smallContent: {
        fontSize: '0.8rem!important',
    },
    elementBlockWrapper: {
        padding: '16px 16px 0 16px',
    },
    header: {
        margin: '0 -16px 16px -16px',
        padding: '8px 32px',
        background: '#ececec',
        maxWidth: 'calc(100% + 32px)',
        flexBasis: 'calc(100% + 32px)',
        fontWeight: '500!important',
    },
    company: {
        float: 'left'
    },
    productType: {
        float: 'right'
    },
    [theme.breakpoints.down(600)]: {
        elementBlockWrapper: {
            padding: '16px 0px 0 0px',
        },
        legend: {
            padding: '0px 0 0px 0!important',
            float: 'left',
            width: 'calc(50% + 8px)',
            [theme.breakpoints.down(600)]: {
                padding: '14px 0 0 0!important',
            }
        },
        elementText: {
            paddingTop: '4px!important',
            marginBottom: '0!important'
        },
        statusIcon: {
            fontSize: '4rem',
        },
        imageWrapper: {
            padding: '8px',
        },
    },
});

class ApplicationElement extends PureComponent {
    render() {
        const {element, classes} = this.props;
        return (
            <Grid container className={classes.elementWrapper + ' application-element'}>
                <Grid item xs={12} sm={12} className={classes.header}>
                    <Typography variant="overline" align="center"
                                style={{fontWeight: 500, lineHeight: 1.4}}>{element.product}</Typography>
                </Grid>
                <Grid item xs={12} sm={3} className={classes.imageWrapper}>
                    {element.image && <img src={element.image} alt="" className={classes.image}/>}
                </Grid>
                <Grid item xs={12} sm={6} className={classes.contentWrapper}>
                    {element.contentElements.topFirst && <Grid container className={classes.elementContentWrapper}>
                        {element.contentElements.topFirst.map((value, index) => {
                            return (
                                <Grid item xs={6} sm={6}>
                                    <Typography variant="overline" align="center"
                                                className={classes.elementTitle}>{value.title}</Typography>
                                    <Typography variant="body2" align="center"
                                                className={classes.elementContent}>{value.content}</Typography>

                                </Grid>)
                        })
                        }
                    </Grid>
                    }
                    {element.contentElements.topSecond && <Grid container className={classes.elementContentWrapper}>
                        {element.contentElements.topSecond.map((value, index) => {
                            return (
                                <Grid item xs={6} sm={6}>
                                    <Typography variant="overline" align="center"
                                                className={classes.elementTitle}>{value.title}</Typography>
                                    <Typography variant="body2" align="center"
                                                className={classes.elementContent}>{value.content}</Typography>

                                </Grid>)
                        })
                        }
                    </Grid>
                    }
                </Grid>
                <Grid item xs={12} sm={3} className={classes.buttonWrapper}>
                    {element.button && <a href={element.button.url} target="_blank">
                        <Fab variant="extended"
                             color="primary"
                             size="medium"
                             disabled={!element.button.active}
                             className={classes.button+' forwardButton'}>
                            {element.button.label}
                            {element.button.icon && <FontAwesomeIcon className={classes.rightIcon} size="lg"
                                                                     icon={['far', element.button.icon]}/>}
                        </Fab>
                    </a>}
                </Grid>
                <Grid item xs={12} sm={12} className={classes.contentWrapper + ' ' + classes.topDivider}>
                    {element.contentElements.bottom && <Grid container>
                        {element.contentElements.bottom.map((value, index) => {
                            const smCols = element.contentElements.bottom.length % 2 === 1 && index === element.contentElements.bottom.length - 1 ? 12 : 6;
                            return (
                                <Grid item xs={12}
                                      sm={smCols}
                                      className={classes.elementBlockWrapper}>
                                    <Typography variant="overline" align="left"
                                                className={classes.elementTitle}>{value.title}</Typography>
                                    <Typography variant="body2" align="left"
                                                className={classes.elementContent + ' ' + classes[value.contentClass]}>{value.content}</Typography>

                                </Grid>)
                        })
                        }
                    </Grid>
                    }
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(styles)(ApplicationElement);
/*
{false && <Grid item xs={8} sm={8} className={classes.contentWrapper}>
                   {element.product &&
                   <Typography variant="h5" gutterBottom className={classes.product}>{element.product}</Typography>}
                   {element.productDescription && <Typography variant="body1"
                                                              className={classes.productDescription}>{element.productDescription}</Typography>}
                   {element.status === 1 && <FontAwesomeIcon className={classes.statusIcon + ' ' + classes.status0Icon}
                                                             icon={['far', 'times-circle']}/>}
                   {element.status === 5 && <FontAwesomeIcon className={classes.statusIcon + ' ' + classes.status5Icon}
                                                             icon={['far', 'question-circle']}/>}
                   {element.status === 7 && <FontAwesomeIcon className={classes.statusIcon + ' ' + classes.status7Icon}
                                                             icon={['far', 'check-circle']}/>}
                   {element.status === 10 &&
                   <FontAwesomeIcon className={classes.statusIcon + ' ' + classes.status10Icon}
                                    icon={['far', 'check-circle']}/>}
                   {element.statusDescription && <Typography variant="body1"
                                                             className={classes.statusDescription}>{element.statusDescription}</Typography>}

               </Grid>}
 */
